import { render, staticRenderFns } from "./Offices.vue?vue&type=template&id=5c68c265&scoped=true"
import script from "./Offices.vue?vue&type=script&lang=js"
export * from "./Offices.vue?vue&type=script&lang=js"
import style0 from "./Offices.vue?vue&type=style&index=0&id=5c68c265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68c265",
  null
  
)

export default component.exports